import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-polycarp',
  imports: [RouterLink, Link],
  templateUrl: './polycarp.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './polycarp.scss',
})
export class Polycarp {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Polycarp`);
    this.dynamicTitle.description(`Polycarp was claimed to be a "hearer" of John by Irenaeus but he never made the claim.`);
  }
}
